import React from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import SuccessImage from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/success/components/service-success/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

export const NoRecords = () => {
	const { formatMessage } = useIntl();
	return (
		<AllGoodContainer>
			<AllGoodContent>
				<Box xcss={imageContainerStyles}>
					<SuccessImage height="150" width="139" alt="no failure logs" />
				</Box>
				<br />
				<h5>{formatMessage(messages.configEnabledAndNoFailureLogsMainText)}</h5>
			</AllGoodContent>
		</AllGoodContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AllGoodContainer = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 62.5}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AllGoodContent = styled.div({
	textAlign: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	h5: {
		padding: token('space.300', '24px'),
		marginTop: 0,
	},
});

const imageContainerStyles = xcss({
	display: 'flex',
	justifyContent: 'center',
});
